import script from "./ReadBookStatus.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReadBookStatus.vue?vue&type=script&lang=ts&setup=true"

import "./ReadBookStatus.vue?vue&type=style&index=0&id=06eee789&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06eee789"]])

export default __exports__